import { createDefaultTyrann } from '@apis/common';
import { contact, contactQuery } from '@models/Contact';
import * as t from 'io-ts';

export const contactApis = createDefaultTyrann({
  '/dashboard/contact/': {
    get: {
      query: contactQuery,
      response: {
        200: t.array(contact),
      },
    },
  },
  '/dashboard/contact/{id}/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: contact,
        404: t.type({}),
      },
    },
  },
});
